export const ROUTES_NAME = {
	HOME: '',
	LOGIN: 'login',
	QUOTATION: 'quotation',
	QUOTATION_DETAIL: 'quotation-detail',
} as const;
